/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum IntegrationEnvironment {
  Sandbox = "sandbox",
  Production = "production",
}

export function instanceOfIntegrationEnvironment(value: any): boolean {
  for (const key in IntegrationEnvironment) {
    if (Object.prototype.hasOwnProperty.call(IntegrationEnvironment, key)) {
      if (
        IntegrationEnvironment[key as keyof typeof IntegrationEnvironment] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function IntegrationEnvironmentFromJSON(
  json: any,
): IntegrationEnvironment {
  return IntegrationEnvironmentFromJSONTyped(json, false);
}

export function IntegrationEnvironmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IntegrationEnvironment {
  return json as IntegrationEnvironment;
}

export function IntegrationEnvironmentToJSON(
  value?: IntegrationEnvironment | null,
): any {
  return value as any;
}

export function IntegrationEnvironmentToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): IntegrationEnvironment {
  return value as IntegrationEnvironment;
}
